import React, { useEffect, useState } from 'react';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DescricaoEntregaModal from './components/modals/DescricaoEntregaModal';
import * as Api from './DescricaoEntregaService';
import DataTable from './components/DataTable';

function DescricaoEntregas() {
  const [list, setList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  const vinculo = (() => {
    try { const v = localStorage.getItem('vinculo'); return v ? JSON.parse(v) : null; } catch(e) { return null; }
  })();

  const load = () => {
    if (!vinculo?.idEntidade) return setLoading(false);
    setLoading(true);
    Api.getList(vinculo.idEntidade)
      .then(data => setList(Array.isArray(data) ? data : []))
      .catch(err => showDefaultModal('error', err?.response?.data || err.message || 'Erro ao carregar'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleNew = () => { setSelected(null); setShowModal(true); };
  const handleEdit = (row) => { setSelected(row); setShowModal(true); };
  const handleDelete = (row) => {
    showConfirmModal('delete', async () => {
      try {
        await Api.deleteDescricao(row.idEntidade, row.id);
        showDefaultModal('success', 'Registro excluído');
        load();
      } catch (err) {
        console.error(err);
        showDefaultModal('error', err?.response?.data || err.message || 'Erro ao excluir');
      }
    });
  };

  const handleSaved = () => { setShowModal(false); load(); };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Descrição de Entrega" icon="bi-card-text" />
        <PageContent>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between gap-2 mb-2 align-items-start align-items-lg-center">
            <div className="botao-grid-2col">
              <button className="btn btn-success btn-sm botao-igual" onClick={handleNew}>
                <i className="bi bi-plus-circle me-1" /> Nova
              </button>
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
              <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  <th style={{ width: '80px' }}>ID</th>
                  <th>Descrição</th>
                  <th style={{ width: '120px' }}>Ações</th>
                </tr>}>
              <tbody>
                {list && list.length > 0 ? list.map((row) => (
                  <tr key={`${row.idEntidade}_${row.id}`}>
                    <td>{row.id}</td>
                    <td>{row.descricao}</td>
                    <td>
                      <div className="d-flex gap-1">
                        <button className="btn btn-primary btn-sm" onClick={() => handleEdit(row)} title="Editar">
                          <i className="bi bi-pencil" />
                        </button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row)} title="Excluir">
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={3} className="text-center">Nenhum registro encontrado.</td></tr>
                )}
              </tbody>
            </DataTable>
            </TableContainer>
        </PageContent>
      </ResponsiveShadow>

      <DescricaoEntregaModal show={showModal} onClose={() => setShowModal(false)} onSave={handleSaved} data={selected} />
      <DefaultModal {...setDefaultModal} />
      <ConfirmModal {...setConfirmModal} />
    </Layout>
  );
}

export default DescricaoEntregas;
